import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, SortDirection, Sorting, StandardLoadOptions } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ClaimService } from 'app/cd/services/claim-service';
import { apiCall } from 'app/shared/lib/api/api';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class ClaimDiagnosisGrid extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public claimId: string | null = null;

    @bindable({ defaultBindingMode: bindingMode.toView })
    protected pageSize: number | undefined = 10;

    private sorting: Sorting = new Sorting();

    protected diagnoses: CD.Diagnosis[] = [];
    protected resultCount: number = 0;

    ////****************** Element References ***************************************////
    protected $pager!: EssPagerCustomElement;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly claimService: ClaimService,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.reload();
    }

    ////****************** Events ***************************************************////
    public async reload(): Promise<void> {
        await this.loadClaimDiagnoses();
    }

    protected async applySort(event: SortChangeEvent): Promise<void> {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        await this.reload();
        //Call stop Propagation to prevent parent table from reload and losing sort
        event.stopPropagation();
    }

    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadClaimDiagnoses(): Promise<void> {
        if(!this.claimId) return;

        const options: StandardLoadOptions = {
            sorting: this.sorting,
            top: this.pageSize,
            page: this.$pager?.page || 0,
            includeInactive: false
        };

        const fields = [
            'code',
            'description'
        ];

        try {
            this.state.beginLoad();

            const responseDiagnoses = await this.claimService.loadDiagnosesByClaim(this.claimId, options, [], fields);
            this.diagnoses = responseDiagnoses.results;
            this.resultCount = responseDiagnoses.count || 0;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
